import React from 'react';

import Align from '@marvelapp/marvel-ui/align';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import tabs from 'marketing-website/configs/pages/homepage/tabs';

export default function PowerfulDesignMobile() {
  return (
    <div>
      {tabs.map(tab => (
        <Spacing size="xl" position="topBottom" type="margin" key={tab.id}>
          <Align type="center">
            <Heading tag="h3" size="xl" weight="semibold">
              {tab.title}
            </Heading>
            <Spacing size="m" position="topBottom" type="margin">
              <Paragraph>{tab.subtitle}</Paragraph>
            </Spacing>
            <Image
              {...tab}
              src={tab.srcMobile}
              alt={tab.title}
              hasShadow={false}
            />
          </Align>
        </Spacing>
      ))}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/PowerfulDesign/PowerfulDesignMobile.js